// extracted by mini-css-extract-plugin
export default {"component":"CheckoutTitle_component__NeuQx","dropdown":"CheckoutTitle_dropdown__RtM7k","item":"CheckoutTitle_item__YGpjo","dark":"CheckoutTitle_dark__fDBgN"};